// import React, { useState, useRef, useEffect } from 'react';
// import { useParams } from 'react-router';

// const PublishAudio = () => {
//   // State variables
//   const { id } = useParams();
//   const [deviceStatus, setDeviceStatus] = useState('Not connected');
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [fileName, setFileName] = useState('No file selected');
//   const [isUploading, setIsUploading] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const [message, setMessage] = useState({ text: '', type: '' });
//   const [logs, setLogs] = useState([]);
//   const [isConnected, setIsConnected] = useState(false);
//   const [showLogs, setShowLogs] = useState(false);
//   const [isDownloading, setIsDownloading] = useState(false);
//   const [initialDownloadComplete, setInitialDownloadComplete] = useState(false);
  

//   // Refs
//   const fileInputRef = useRef(null);
//   const logContainerRef = useRef(null);

//   // HID device reference
//   const deviceRef = useRef(null);
  
//   // Protocol constants
//   const m_report_len = 65;
//   const m_gNumberRef = useRef(0x01);

//   // Check WebHID support and download ZIP file when page loads
//   useEffect(() => {
//     if (!('hid' in navigator)) {
//       addLog('WebHID is not supported in this browser');
//       setMessage({
//         text: 'WebHID is not supported in this browser',
//         type: 'error'
//       });
//     }

//     if (!initialDownloadComplete) {
//       downloadZipFile();
//       setInitialDownloadComplete(true);
//     }
//   }, [initialDownloadComplete]);

//   // Function to download the ZIP file from the API
//   // Function to download the ZIP file from the API
// const downloadZipFile = async () => {
//     try {
//       setIsDownloading(true);
//       addLog('Downloading ZIP file from API...');
      
//       const response = await fetch(`https://api.dqr-display-tms.eventum.co.in/api/Share/Audio/${id}`, {
//         method: 'GET',
//         headers: {
//           'accept': '*/*'
//         }
//       });
      
//       if (!response.ok) {
//         throw new Error(`API request failed with status ${response.status}`);
//       }
      
//       // Get the blob from response
//       const blob = await response.blob();
      
//       // Get filename
//       const filename = getFilenameFromResponse(response) || 'Audio.zip';
      
//       // Create a file from the blob for the application
//       const file = new File([blob], filename, { type: 'application/zip' });
      
//       // Save file to application state
//       setSelectedFile(file);
//       setFileName(filename);
      
//       // Additionally, create a download link to save the file locally
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.style.display = 'none';
//       a.href = url;
//       a.download = filename;
//       document.body.appendChild(a);
//       a.click();
      
//       // Clean up
//       window.URL.revokeObjectURL(url);
//       document.body.removeChild(a);
      
//       setIsDownloading(false);
//       addLog(`ZIP file downloaded successfully: ${filename}`);
//       setMessage({ text: 'ZIP file downloaded successfully', type: 'success' });
//     } catch (error) {
//       setIsDownloading(false);
//       addLog(`Error downloading ZIP file: ${error.message}`);
//       setMessage({ text: `Download failed: ${error.message}`, type: 'error' });
//     }
//   };
  
//   // Helper function to extract filename from response headers
//   const getFilenameFromResponse = (response) => {
//     const contentDisposition = response.headers.get('content-disposition');
//     if (contentDisposition) {
//       const filenameMatch = contentDisposition.match(/filename="?([^"]*)"?/);
//       if (filenameMatch && filenameMatch[1]) {
//         return filenameMatch[1];
//       }
//     }
//     return null;
//   };

//   // Function to add logs
//   const addLog = (logMessage) => {
//     setLogs(prevLogs => [...prevLogs, logMessage]);
//     // Scroll to the bottom of the log container
//     if (logContainerRef.current) {
//       setTimeout(() => {
//         logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
//       }, 0);
//     }
//   };

//   // Buffer to hex string conversion for logging
//   const bufferToHexString = (buffer) => {
//     return Array.from(new Uint8Array(buffer))
//       .map(b => b.toString(16).padStart(2, '0').toUpperCase())
//       .join(' ');
//   };

//   // LRC (Longitudinal Redundancy Check) function
//   const lrc = (data) => {
//     let cLRC = 0;
//     for (let i = 0; i < data.length; i++) {
//       cLRC ^= data[i];
//     }
//     return cLRC;
//   };

//   // Additional LRC function
//   const LRC = (cLRC, data) => {
//     for (let i = 0; i < data.length; i++) {
//       cLRC ^= data[i];
//     }
//     return cLRC;
//   };

//   // Check if command is illegal
//   const IsIllegalCMD = (cmd, buff) => {
//     if (buff[0] !== cmd[0] || buff[1] !== cmd[1]) {
//       const err = `request cmd [${cmd[0].toString(16).padStart(2, '0').toUpperCase()}${cmd[1].toString(16).padStart(2, '0').toUpperCase()}] is not equal to response cmd [${buff[0].toString(16).padStart(2, '0').toUpperCase()}${buff[1].toString(16).padStart(2, '0').toUpperCase()}]`;
//       return { valid: false, error: err };
//     }

//     if (buff[2] === 0x00 && buff[3] === 0x00) {
//       return { valid: true, error: "" };
//     }

//     const err = `cmd return fail [${buff[2].toString(16).padStart(2, '0').toUpperCase()}${buff[3].toString(16).padStart(2, '0').toUpperCase()}]`;
//     return { valid: false, error: err };
//   };

//   // Send a command with data to the device
//   const cs_send = async (cmd, data, dataLen, outLRC) => {
//     if (!deviceRef.current) { 
//       addLog('Device not connected'); 
//       return -1; 
//     }

//     const cmdData = new Uint8Array(1024 * 10);          // work buffer
//     cmdData[2] = 0x02;
//     cmdData[3] = m_gNumberRef.current;
//     cmdData[4] = cmd[0];
//     cmdData[5] = cmd[1];

//     const bufflen = m_report_len - 9;                   // max payload in 1st frame
//     cmdData[6] = dataLen >> 8;
//     cmdData[7] = dataLen & 0xFF;

//     let reallen = dataLen;
//     if (dataLen > 0) {
//       if (dataLen > bufflen) {
//         cmdData.set(data.subarray(0, bufflen + 1), 8);
//         reallen = bufflen + 1;                      // we'll send remainder later
//       } else {
//         cmdData.set(data.subarray(0, dataLen), 8);
//       }
//     }

//     m_gNumberRef.current = (m_gNumberRef.current === 0xFF ? 0x01 : m_gNumberRef.current + 1);

//     /* ---------- LRC ---------- */
//     let length, cLRC;
//     if (dataLen > bufflen) {
//       length = 6 + reallen;                           // 0x02 seq cmd cmd len-hi len-lo + realLen
//       cLRC = lrc(cmdData.subarray(2, 6 + reallen));
//       outLRC[0] = cLRC;                               // return via out parameter
//     } else {
//       cLRC = lrc(cmdData.subarray(2, 6 + reallen));
//       cmdData[8 + reallen] = cLRC;                    // append when single-frame
//       length = 7 + reallen;                           // 6-byte hdr + realLen + LRC
//     }

//     /* total length (big-endian) */
//     cmdData[0] = length >> 8;
//     cmdData[1] = length & 0xFF;

//     length = length + 2;                                   // include those 2 bytes

//     if (length > m_report_len) {
//       addLog('❌ packet larger than report size');
//       return -1;
//     }

//     // Send the data using the device's sendReport method
//     try {
//       const res = await deviceRef.current.sendReport(0, cmdData.slice(1, length));
//       if (res < 0) {
//         return res; // Return error if write failed
//       }
//       return res;
//     } catch (error) {
//       addLog(`Send error: ${error.message}`);
//       return -1;
//     }
//   };

//   // Read data from the device with timeout
//   const cs_read = async (timeout_ms) => {
//     return new Promise((resolve) => {
//       const timeoutId = setTimeout(() => {
//         resolve({ length: 0, data: new Uint8Array(0) });
//       }, timeout_ms);

//       deviceRef.current.addEventListener('inputreport', function onInputReport(event) {
//         clearTimeout(timeoutId);
//         deviceRef.current.removeEventListener('inputreport', onInputReport);


//         const data = new Uint8Array(event.data.buffer);
//         addLog(`Received: ${bufferToHexString(data)}`);

//         if (data.length === 0) {
//           resolve({ length: -99, data: new Uint8Array(0) });
//           return;
//         }

//         const len_byte = data[0];

//         if (len_byte < 7) {
//           resolve({ length: -1, data: new Uint8Array(0) });
//           return;
//         }

//         if (data[1] !== 0x02) {
//           resolve({ length: -2, data: new Uint8Array(0) });
//           return;
//         }

//         const cmdtype = data[3];
//         const cmd = data[4];
//         const datalen = (data[5] << 8) | data[6];

//         if (datalen > 0 && datalen === len_byte - 7) {
//           const resultData = new Uint8Array(datalen + 2);
//           resultData[0] = cmdtype;
//           resultData[1] = cmd;
//           resultData.set(data.slice(7, 7 + datalen), 2);
//           resolve({ length: datalen + 2, data: resultData });
//         } else {
//           resolve({ length: -3, data: new Uint8Array(0) });
//         }
//       }, { once: true });
//     });
//   };

//   // Process and send the file via HID communication
//   const processFile = async (file, cmd) => {
//     try {
//       addLog(`Processing file: ${file.name}`);
//       setMessage({ text: 'Upload started...', type: 'info' });

//       const fileBuffer = await file.arrayBuffer();
//       const fileData = new Uint8Array(fileBuffer);

//       const filelen = fileData.length;
//       let rlen = filelen;
//       const bufflen = m_report_len - 9 - 12;
//       let nRead = 0;
//       let startAddr = 0;

//       addLog(`File size: ${filelen} bytes`);

//       // Prepare the packet to send
//       const pt = new Uint8Array(1024);

//       while (rlen > 0) {
//         // Calculate length of the chunk to read
//         const len = Math.min(rlen, 4 * 1024);
//         const buff = fileData.slice(startAddr, startAddr + len);

//         // Convert startAddr to big-endian bytes
//         pt[0] = (startAddr >> 24) & 0xFF;
//         pt[1] = (startAddr >> 16) & 0xFF;
//         pt[2] = (startAddr >> 8) & 0xFF;
//         pt[3] = startAddr & 0xFF;

//         // Convert length to big-endian bytes
//         pt[4] = (len >> 24) & 0xFF;
//         pt[5] = (len >> 16) & 0xFF;
//         pt[6] = (len >> 8) & 0xFF;
//         pt[7] = len & 0xFF;

//         // Convert filelen to big-endian bytes
//         pt[8] = (filelen >> 24) & 0xFF;
//         pt[9] = (filelen >> 16) & 0xFF;
//         pt[10] = (filelen >> 8) & 0xFF;
//         pt[11] = filelen & 0xFF;

//         // If the data length is within buffer size, send it all at once
//         if (len <= bufflen) {
//           pt.set(buff, 12);
//           const datalen = 12 + len;
//           const outLRC = new Uint8Array(1);
//           const res = await cs_send(cmd, pt.slice(0, datalen), datalen, outLRC);
//           if (res <= 0) {
//             throw new Error("Failed to send data.");
//           }
//         } else {
//           // Handle data chunks larger than buffer length
//           pt.set(buff.slice(0, bufflen + 1), 12);
//           const datalen = 12 + len;
//           const outLRC = new Uint8Array(1);
//           const res = await cs_send(cmd, pt.slice(0, datalen), datalen, outLRC);
//           if (res <= 0) {
//             throw new Error("Failed to send data.");
//           }

//           let packlen = len;
//           let pCur = bufflen + 1;
//           packlen = packlen - bufflen - 1;
//           let curlen = 0;
//           let sendlen = 0;
//           let bSendLRC = false;
//           let cLRC = 0;

//           // Sending remaining data in chunks
//           while (packlen > 0) {
//             curlen = Math.min(packlen, m_report_len - 2);
//             const tempBuff = buff.slice(pCur, pCur + curlen);

//             cLRC = LRC(cLRC, tempBuff);

//             if (curlen < m_report_len - 2) {
//               pt[0] = ((curlen + 1) >> 8) & 0xFF;  // High byte
//               pt[1] = (curlen + 1) & 0xFF;         // Low byte
//               pt.set(tempBuff, 2);                 // Copy data
//               pt[2 + curlen] = cLRC;               // LRC byte
//               sendlen = 3 + curlen;
//               bSendLRC = true;
//             } else {
//               pt[0] = (curlen >> 8) & 0xFF;        // High byte
//               pt[1] = curlen & 0xFF;               // Low byte
//               pt.set(tempBuff, 2);                 // Copy data
//               sendlen = 2 + curlen;
//             }

//             addLog(`[SEND cs_send] ${bufferToHexString(pt.slice(0, sendlen))}`);
//             await deviceRef.current.sendReport(0, pt.slice(1, sendlen));

//             pCur = pCur + curlen;
//             packlen = packlen - curlen;
//           }

//           if (!bSendLRC) {
//             pt[0] = (1 >> 8) & 0xFF;     // High byte of 1
//             pt[1] = 1 & 0xFF;            // Low byte of 1
//             pt[2] = cLRC;                // LRC byte

//             addLog(`Sending LRC: ${bufferToHexString(pt.slice(0, 3))}`);
//             const ret = await deviceRef.current.sendReport(0, pt.slice(0, 3));
//             if (ret <= 0) {
//               throw new Error("Download failed");
//             }
//           }
//         }

//         const { length: ret, data: readBuff } = await cs_read(3000);
//         if (ret <= 0) {
//           throw new Error("Download failed - Read timeout");
//         }

//         const { valid: iicValid, error: iicErr } = IsIllegalCMD(cmd, readBuff);
//         if (!iicValid) {
//           addLog(`Error: ${iicErr}`);
//         }

//         rlen = rlen - len;
//         startAddr = startAddr + len;

//         const currentProgress = Math.floor((startAddr / filelen) * 100);
//         setProgress(currentProgress);
//         addLog(`Progress: ${startAddr}/${filelen} bytes sent (${currentProgress}%)`);
//       }

//       addLog("File upload completed!");
//       setMessage({ text: 'Upload completed successfully!', type: 'success' });
//       return true;
//     } catch (error) {
//       addLog(`Error: ${error.message}`);
//       setMessage({ text: `Upload failed: ${error.message}`, type: 'error' });
//       return false;
//     }
//   };

//   // Connect to HID device
//   const handleConnect = async () => {
//     try {
//       const devices = await navigator.hid.requestDevice({
//         filters: [{ vendorId: 0x2C7C, productId: 0x0901 }]
//       });

//       if (devices.length === 0) {
//         addLog('No device selected');
//         return;
//       }

//       deviceRef.current = devices[0];
//       await deviceRef.current.open();

//       setDeviceStatus(`Connected: ${deviceRef.current.productName} VID 0x2C7C, PID 0x0901 `);
//       setIsConnected(true);
//       addLog(`Connected to ${deviceRef.current.productName}`);
//     } catch (error) {
//       addLog(`Error connecting to device: ${error.message}`);
//       setMessage({ text: `Connection error: ${error.message}`, type: 'error' });
//     }
//   };

//   // Handle file upload
//   const handleUpload = async () => {
//     if (!deviceRef.current) {
//       addLog('Please connect to a device first');
//       setMessage({ text: 'Please connect to a device first', type: 'error' });
//       return;
//     }

//     if (!selectedFile) {
//       addLog('No ZIP file available. Trying to download again...');
//       await downloadZipFile();
//       if (!selectedFile) {
//         setMessage({ text: 'Failed to get ZIP file', type: 'error' });
//         return;
//       }
//     }

//     setIsUploading(true);
//     setProgress(0);
//     setMessage({ text: '', type: '' });

//     // Command to send
//     const cmd = new Uint8Array([0x03, 0x16]);

//     await processFile(selectedFile, cmd);
//     setIsUploading(false);
//   };
  
//   // Custom Icon Components
//   const CloudUploadIcon = () => (
//     <div style={{ display: 'inline-block', marginRight: '10px' }}>
//       <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M10 0L5 5H8V10H12V5H15L10 0Z" fill="white"/>
//         <path d="M18 9H16V13H4V9H2V13C2 14.1 2.9 15 4 15H16C17.1 15 18 14.1 18 13V9Z" fill="white"/>
//       </svg>
//     </div>
//   );
  
//   const DownloadIcon = () => (
//     <div style={{ display: 'inline-block', marginRight: '10px' }}>
//       <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M15 4H12V0H8V4H5L10 9L15 4Z" fill="white"/>
//         <path d="M18 11H16V15H4V11H2V15C2 16.1 2.9 17 4 17H16C17.1 17 18 16.1 18 15V11Z" fill="white"/>
//       </svg>
//     </div>
//   );
  
//   const CheckIcon = () => (
//     <div style={{ display: 'inline-block', marginRight: '5px' }}>
//       <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM6 12L2 8L3.4 6.6L6 9.2L12.6 2.6L14 4L6 12Z" fill="currentColor"/>
//       </svg>
//     </div>
//   );
  
//   const ErrorIcon = () => (
//     <div style={{ display: 'inline-block', marginRight: '5px' }}>
//       <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM9 12H7V10H9V12ZM9 8H7V4H9V8Z" fill="currentColor"/>
//       </svg>
//     </div>
//   );
  
//   const InfoIcon = () => (
//     <div style={{ display: 'inline-block', marginRight: '5px' }}>
//       <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM9 12H7V7H9V12ZM8 6C7.4 6 7 5.6 7 5C7 4.4 7.4 4 8 4C8.6 4 9 4.4 9 5C9 5.6 8.6 6 8 6Z" fill="currentColor"/>
//       </svg>
//     </div>
//   );

//   return (
//     <div style={{
//       fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//       background: "linear-gradient(135deg, #e0f7fa 0%, #fce4ec 100%)",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       height: "100vh",
//       margin: 0,
//       padding: "20px"
//     }}>
//       <div style={{
//         background: "#ffffffee",
//         backdropFilter: "blur(10px)",
//         boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
//         borderRadius: "15px",
//         width: "450px",
//         maxWidth: "90vw",
//         padding: "35px",
//         textAlign: "center",
//         border: "1px solid rgba(0, 0, 0, 0.05)"
//       }}>
//         <h2 style={{
//           marginBottom: "25px",
//           color: "#2c3e50",
//           fontWeight: 700,
//           letterSpacing: "1px"
//         }}>Upload Audio</h2>
        
//         <button 
//           style={{
//             backgroundColor: isConnected ? "#848b92" : "#007bff",
//             color: "white",
//             fontSize: "16px",
//             padding: "12px 25px",
//             border: "none",
//             borderRadius: "8px",
//             cursor: isConnected ? "not-allowed" : "pointer",
//             transition: "all 0.3s ease",
//             boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
//             fontWeight: 600,
//             opacity: isConnected ? 0.6 : 1
//           }}
//           onClick={handleConnect} 
//           disabled={isConnected || !('hid' in navigator)}
//         >
//           Connect Device
//         </button>
        
//         <br />
//         <br />
        
//         <span style={{
//           fontSize: "14px",
//           color: "#999",
//           marginTop: "-15px",
//           marginBottom: "20px",
//           display: "block"
//         }}>
//           {deviceStatus}
//         </span>
      
//         <div style={{
//           margin: "25px 0",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           gap: "15px"
//         }}>
//           <button 
//             onClick={downloadZipFile}
//             disabled={isDownloading}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               padding: "14px 28px",
//               background: isDownloading ? "#848b92" : "linear-gradient(45deg, #2196F3 30%, #64B5F6 90%)",
//               color: "white",
//               fontSize: "16px",
//               fontWeight: 600,
//               borderRadius: "8px",
//               cursor: isDownloading ? "not-allowed" : "pointer",
//               transition: "all 0.3s ease",
//               boxShadow: "0 4px 15px rgba(33, 150, 243, 0.3)",
//               border: "none",
//               opacity: isDownloading ? 0.7 : 1
//             }}
//           >
//             <DownloadIcon /> {isDownloading ? 'Downloading...' : 'Download ZIP File'}
//           </button>
          
//           <div style={{
//             fontSize: "15px",
//             color: "#555",
//             padding: "8px 16px",
//             border: "1px dashed #ccc",
//             borderRadius: "6px",
//             minHeight: "24px",
//             transition: "all 0.3s",
//             backgroundColor: "#f8f9fa",
//             width: "100%",
//             boxSizing: "border-box"
//           }}>
//             {isDownloading ? 'Downloading...' : fileName}
//           </div>
//         </div>
      
//         <div style={{
//           width: "100%",
//           border: "1px solid #ddd",
//           padding: "3px",
//           borderRadius: "3px",
//           marginTop: "10px",
//           boxSizing: "border-box"
//         }}>
//           <div style={{
//             height: "20px",
//             backgroundColor: "#4CAF50",
//             width: `${progress}%`,
//             borderRadius: "2px",
//             textAlign: "center",
//             lineHeight: "20px",
//             color: "white",
//             transition: "width 0.3s ease"
//           }}>
//             {progress}%
//           </div>
//         </div>
      
//         <div style={{
//           display: "flex",
//           justifyContent: "center",
//           gap: "20px",
//           marginTop: "25px"
//         }}>
//           <button 
//             style={{
//               backgroundColor: (!isConnected || !selectedFile || isUploading || isDownloading) ? "#848b92" : "#007bff",
//               color: "white",
//               fontSize: "16px",
//               padding: "12px 25px",
//               border: "none",
//               borderRadius: "8px",
//               cursor: (!isConnected || !selectedFile || isUploading || isDownloading) ? "not-allowed" : "pointer",
//               transition: "all 0.3s ease",
//               boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
//               fontWeight: 600,
//               opacity: (!isConnected || !selectedFile || isUploading || isDownloading) ? 0.6 : 1
//             }}
//             onClick={handleUpload} 
//             disabled={!isConnected || !selectedFile || isUploading || isDownloading}
//           >
//             Upload to Device
//           </button>
//         </div>
      
//         {message.text && (
//           <div style={{
//             marginTop: "15px",
//             fontSize: "15px",
//             minHeight: "20px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "8px",
//             transition: "all 0.3s ease",
//             color: message.type === 'success' ? '#2e7d32' : message.type === 'error' ? '#c62828' : '#0277bd'
//           }}>
//             {message.type === 'success' ? <CheckIcon /> : 
//              message.type === 'error' ? <ErrorIcon /> : 
//              message.type === 'info' ? <InfoIcon /> : null}
//             <div>{message.text}</div>
//           </div>
//         )}
      
//         <button 
//           style={{
//             marginTop: "20px",
//             background: "none",
//             border: "1px solid #ccc",
//             padding: "8px 16px",
//             borderRadius: "4px",
//             cursor: "pointer",
//             color: "#666",
//             fontSize: "14px",
//             transition: "all 0.2s"
//           }}
//           onClick={() => setShowLogs(!showLogs)}
//         >
//           {showLogs ? 'Hide Logs' : 'Show Logs'}
//         </button>
  
//         {showLogs && (
//           <div 
//             style={{
//               marginTop: "20px",
//               maxHeight: "150px",
//               overflowY: "auto",
//               textAlign: "left",
//               fontSize: "13px",
//               color: "#666",
//               background: "#f8f8f8",
//               padding: "10px",
//               borderRadius: "6px"
//             }}
//             ref={logContainerRef}
//           >
//             {logs.map((log, index) => (
//               <div key={index}>{log}</div>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PublishAudio;
import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router';

const PublishAudio = () => {
  const { id } = useParams();
  const [deviceStatus, setDeviceStatus] = useState('Not connected');
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('No file selected');
  const [isUploading, setIsUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState({ text: '', type: '' });
  const [logs, setLogs] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const [showLogs, setShowLogs] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [apiError, setApiError] = useState(null); // New state for API errors

  const logContainerRef = useRef(null);
  const deviceRef = useRef(null);
  const fileInputRef = useRef(null);

  const m_report_len = 65;
  const m_gNumberRef = useRef(0x01);

  // Log helper
  const addLog = (logMessage) => {
    setLogs(prevLogs => [...prevLogs, `${new Date().toLocaleTimeString()}: ${logMessage}`]);
    setTimeout(() => {
      if (logContainerRef.current)
        logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
    }, 0);
  };

  // Download ZIP file
  const downloadZipFile = async () => {
    try {
      setIsDownloading(true);
      setApiError(null); // Clear previous errors
      addLog('Downloading ZIP file from API...');
      
      const response = await fetch(`https://api.dqr-display-tms.eventum.co.in/api/Share/Audio/${id}`, {
        method: 'GET',
        headers: {
          'accept': '*/*'
        }
      });

      if (!response.ok) {
        throw new Error(`API request failed with status ${response.status}`);
      }

      // Check if response is JSON (error response)
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        const errorData = await response.json();
        if (errorData.errormsg && errorData.errormsg.includes('No matching records found')) {
          setApiError('No matching records found - Your link has expired');
          addLog('Error: No matching records found - Link expired');
          setIsDownloading(false);
          return;
        }
      }

      const blob = await response.blob();
      const filename = getFilenameFromResponse(response) || 'Audio.zip';
      const file = new File([blob], filename, { type: 'application/zip' });

      setSelectedFile(file);
      setFileName(filename);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      setIsDownloading(false);
      addLog(`ZIP file downloaded successfully: ${filename}`);
      setMessage({ text: 'ZIP file downloaded successfully', type: 'success' });
    } catch (error) {
      setIsDownloading(false);
      addLog(`Error downloading ZIP file: ${error.message}`);
      
      // Check if it's a "No matching records found" error
      if (error.message.includes('No matching records found') || error.message.includes('404')) {
        setApiError('No matching records found - Your link has expired');
      } else {
        setMessage({ text: `Download failed: ${error.message}`, type: 'error' });
      }
    }
  };

  // Extract filename from Content-Disposition header
  const getFilenameFromResponse = (response) => {
    const contentDisposition = response.headers.get('content-disposition');
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?([^"]*)"?/);
      if (filenameMatch && filenameMatch[1]) return filenameMatch[1];
    }
    return null;
  };

  // Connect to HID device
  const handleConnect = async () => {
    try {
      const devices = await navigator.hid.requestDevice({
        filters: [{ vendorId: 0x2C7C, productId: 0x0901 }]
      });

      if (devices.length === 0) {
        addLog('No device selected');
        setMessage({ text: 'No device selected', type: 'info' });
        return;
      }

      const selectedDevice = devices[0];
      await selectedDevice.open();
      deviceRef.current = selectedDevice;
      setDeviceStatus(`Connected: ${selectedDevice.productName} VID 0x2C7C, PID 0x0901`);
      setIsConnected(true);
      addLog(`Connected to ${selectedDevice.productName}`);
    } catch (error) {
      addLog(`Connection error: ${error.message}`);
      setMessage({ text: `Connection error: ${error.message}`, type: 'error' });
    }
  };

  // Upload ZIP to Device
  const handleUpload = async () => {
    if (!deviceRef.current) {
      addLog('Please connect to a device first');
      setMessage({ text: 'Please connect to a device first', type: 'error' });
      return;
    }

    if (!selectedFile) {
      addLog('No ZIP file available. Trying to download again...');
      await downloadZipFile();
      if (!selectedFile) {
        setMessage({ text: 'Failed to get ZIP file', type: 'error' });
        return;
      }
    }

    setIsUploading(true);
    setProgress(0);
    setMessage({ text: '', type: '' });

    const cmd = new Uint8Array([0x03, 0x16]);
    await processFile(selectedFile, cmd);
    setIsUploading(false);
  };

  // Process and send file
  const processFile = async (file, cmd) => {
    try {
      addLog(`Processing file: ${file.name}`);
      setMessage({ text: 'Upload started...', type: 'info' });
      const fileBuffer = await file.arrayBuffer();
      const fileData = new Uint8Array(fileBuffer);
      const filelen = fileData.length;
      let rlen = filelen;
      const bufflen = m_report_len - 9 - 12;
      let startAddr = 0;

      while (rlen > 0) {
        const len = Math.min(rlen, 4 * 1024);
        const buff = fileData.slice(startAddr, startAddr + len);
        const pt = new Uint8Array(1024);

        pt[0] = (startAddr >> 24) & 0xFF;
        pt[1] = (startAddr >> 16) & 0xFF;
        pt[2] = (startAddr >> 8) & 0xFF;
        pt[3] = startAddr & 0xFF;

        pt[4] = (len >> 24) & 0xFF;
        pt[5] = (len >> 16) & 0xFF;
        pt[6] = (len >> 8) & 0xFF;
        pt[7] = len & 0xFF;

        pt[8] = (filelen >> 24) & 0xFF;
        pt[9] = (filelen >> 16) & 0xFF;
        pt[10] = (filelen >> 8) & 0xFF;
        pt[11] = filelen & 0xFF;

        pt.set(buff, 12);
        const datalen = 12 + len;
        const outLRC = new Uint8Array(1);
        const res = await cs_send(cmd, pt.slice(0, datalen), datalen, outLRC);

        if (res <= 0) throw new Error("Failed to send data.");

        const { data: readBuff } = await cs_read(3000);
        const { valid } = IsIllegalCMD(cmd, readBuff);
        if (!valid) continue;

        rlen -= len;
        startAddr += len;
        const currentProgress = Math.floor((startAddr / filelen) * 100);
        setProgress(currentProgress);
        addLog(`Progress: ${startAddr}/${filelen} bytes sent (${currentProgress}%)`);
      }

      addLog("File upload completed!");
      setMessage({ text: 'Upload completed successfully!', type: 'success' });
    } catch (error) {
      addLog(`Error: ${error.message}`);
      setMessage({ text: `Upload failed: ${error.message}`, type: 'error' });
    } finally {
      setIsUploading(false);
    }
  };

  // Send command to device
  const cs_send = async (cmd, data, dataLen, outLRC) => {
    if (!deviceRef.current) {
      addLog('Device not connected');
      return -1;
    }

    const cmdData = new Uint8Array(1024 * 10);
    cmdData[2] = 0x02;
    cmdData[3] = m_gNumberRef.current;
    cmdData[4] = cmd[0];
    cmdData[5] = cmd[1];

    const bufflen = m_report_len - 9;
    cmdData[6] = dataLen >> 8;
    cmdData[7] = dataLen & 0xFF;

    let reallen = dataLen;
    if (dataLen > 0) {
      if (dataLen > bufflen) {
        cmdData.set(data.subarray(0, bufflen + 1), 8);
        reallen = bufflen + 1;
      } else {
        cmdData.set(data, 8);
      }
    }

    m_gNumberRef.current = m_gNumberRef.current === 0xFF ? 0x01 : m_gNumberRef.current + 1;

    let length, cLRC;
    if (dataLen > bufflen) {
      length = 6 + reallen;
      cLRC = lrc(cmdData.subarray(2, 6 + reallen));
      outLRC[0] = cLRC;
    } else {
      cLRC = lrc(cmdData.subarray(2, 6 + reallen));
      cmdData[8 + reallen] = cLRC;
      length = 7 + reallen;
    }

    cmdData[0] = length >> 8;
    cmdData[1] = length & 0xFF;
    length += 2;

    if (length > m_report_len) {
      addLog('❌ packet larger than report size');
      return -1;
    }

    try {
      const res = await deviceRef.current.sendReport(0, cmdData.slice(1, length));
      return res;
    } catch (e) {
      addLog(`Send error: ${e.message}`);
      return -1;
    }
  };

  // Read input report
  const cs_read = async (timeout_ms) => {
    return new Promise((resolve) => {
      const timeoutId = setTimeout(() => resolve({ length: 0, data: new Uint8Array(0) }), timeout_ms);
      deviceRef.current.addEventListener('inputreport', function onInputReport(event) {
        clearTimeout(timeoutId);
        deviceRef.current.removeEventListener('inputreport', onInputReport);
        const data = new Uint8Array(event.data.buffer);
        addLog(`Received: ${bufferToHexString(data)}`);
        const len_byte = data[0];
        if (len_byte < 7) return resolve({ length: -1, data: new Uint8Array(0) });
        if (data[1] !== 0x02) return resolve({ length: -2, data: new Uint8Array(0) });

        const datalen = (data[5] << 8) | data[6];
        if (datalen > 0 && datalen === len_byte - 7) {
          const resultData = new Uint8Array(datalen + 2);
          resultData[0] = data[3];
          resultData[1] = data[4];
          resultData.set(data.slice(7, 7 + datalen), 2);
          resolve({ length: datalen + 2, data: resultData });
        } else {
          resolve({ length: -3, data: new Uint8Array(0) });
        }
      }, { once: true });
    });
  };

  // LRC functions
  const lrc = (data) => {
    let cLRC = 0;
    for (let i = 0; i < data.length; i++) cLRC ^= data[i];
    return cLRC;
  };

  const IsIllegalCMD = (cmd, buff) => {
    if (buff[0] !== cmd[0] || buff[1] !== cmd[1]) {
      const err = `request cmd [${cmd[0].toString(16).padStart(2, '0').toUpperCase()}${cmd[1].toString(16).padStart(2, '0').toUpperCase()}] != response cmd [${buff[0].toString(16).padStart(2, '0').toUpperCase()}${buff[1].toString(16).padStart(2, '0').toUpperCase()}]`;
      return { valid: false, error: err };
    }
    if (buff[2] === 0x00 && buff[3] === 0x00) return { valid: true, error: "" };
    const err = `cmd return fail [${buff[2].toString(16).padStart(2, '0').toUpperCase()}${buff[3].toString(16).padStart(2, '0').toUpperCase()}]`;
    return { valid: false, error: err };
  };

  const bufferToHexString = (buffer) =>
    Array.from(new Uint8Array(buffer))
      .map(b => b.toString(16).padStart(2, '0').toUpperCase())
      .join(' ');

  // Icon Components
  const CloudUploadIcon = () => (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0L5 5H8V10H12V5H15L10 0Z" fill="white"/>
      <path d="M18 9H16V13H4V9H2V13C2 14.1 2.9 15 4 15H16C17.1 15 18 14.1 18 13V9Z" fill="white"/>
    </svg>
  );

  const DownloadIcon = () => (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 4H12V0H8V4H5L10 9L15 4Z" fill="white"/>
      <path d="M18 11H16V15H4V11H2V15C2 16.1 2.9 17 4 17H16C17.1 17 18 16.1 18 15V11Z" fill="white"/>
    </svg>
  );

  const CheckIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
      <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM6 12L2 8L3.4 6.6L6 9.2L12.6 2.6L14 4L6 12Z" />
    </svg>
  );

  const ErrorIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
      <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM9 12H7V10H9V12ZM9 8H7V4H9V8Z" />
    </svg>
  );

  const InfoIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
      <path d="M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM9 12H7V7H9V12ZM8 6C7.4 6 7 5.6 7 5C7 4.4 7.4 4 8 4C8.6 4 9 4.4 9 5C9 5.6 8.6 6 8 6Z" />
    </svg>
  );

  // Message display
  const messageDisplay = ({ text, type }) => {
    if (!text) return null;

    const icon = type === 'success' ? <CheckIcon /> :
                 type === 'error' ? <ErrorIcon /> :
                 <InfoIcon />;

    return (
      <div style={{
        marginTop: "15px",
        fontSize: "15px",
        minHeight: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        color: type === 'success' ? '#2e7d32' : type === 'error' ? '#c62828' : '#0277bd'
      }}>
        {icon}
        <div>{text}</div>
      </div>
    );
  };

  useEffect(() => {
    if (!('hid' in navigator)) {
      addLog('WebHID is not supported in this browser');
      setMessage({ text: 'WebHID is not supported in this browser', type: 'error' });
    }
  }, []);

  // If there's an API error (link expired), show full-screen error message
  if (apiError) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#ffffff',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        margin: 0,
        padding: 0
      }}>
        <div style={{
          textAlign: 'center',
          padding: '40px',
          maxWidth: '600px'
        }}>
          <div style={{
            fontSize: '64px',
            marginBottom: '30px',
            color: '#dc3545'
          }}>
            ⚠️
          </div>
          <h1 style={{
            fontSize: '28px',
            color: '#dc3545',
            marginBottom: '20px',
            fontWeight: 700,
            letterSpacing: '1px'
          }}>
            Link Expired
          </h1>
          <p style={{
            fontSize: '18px',
            color: '#666',
            lineHeight: '1.6',
            marginBottom: '30px'
          }}>
            No matching records found. Your download link has expired and is no longer valid.
          </p>
          <p style={{
            fontSize: '16px',
            color: '#888',
            lineHeight: '1.5'
          }}>
            Please contact the administrator to get a new link or verify the URL is correct.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      background: "linear-gradient(135deg, #e0f7fa 0%, #fce4ec 100%)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      margin: 0,
      padding: "20px"
    }}>
      <div style={{
        background: "#ffffffee",
        backdropFilter: "blur(10px)",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
        borderRadius: "15px",
        width: "450px",
        maxWidth: "90vw",
        padding: "35px",
        textAlign: "center",
        border: "1px solid rgba(0, 0, 0, 0.05)"
      }}>
        <h2 style={{
          marginBottom: "25px",
          color: "#2c3e50",
          fontWeight: 700,
          letterSpacing: "1px"
        }}>Upload Audio</h2>

        {/* Connect Button */}
        <button
          onClick={handleConnect}
          disabled={isConnected}
          style={{
            backgroundColor: isConnected ? "#848b92" : "#007bff",
            color: "white",
            fontSize: "16px",
            padding: "12px 25px",
            border: "none",
            borderRadius: "8px",
            cursor: isConnected ? "not-allowed" : "pointer",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            fontWeight: 600,
            opacity: isConnected ? 0.6 : 1
          }}
        >
          {isConnected ? 'Connected' : 'Connect Device'}
        </button>
        <br />
        <span style={{
          fontSize: "14px",
          color: "#999",
          marginTop: "-15px",
          marginBottom: "20px",
          display: "block"
        }}>{deviceStatus}</span>

        {/* Download ZIP Button */}
        <div style={{
          margin: "25px 0",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "15px"
        }}>
          <button
            onClick={downloadZipFile}
            disabled={isDownloading}
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "14px 28px",
              background: isDownloading ? "#848b92" : "linear-gradient(45deg, #2196F3 30%, #64B5F6 90%)",
              color: "white",
              fontSize: "16px",
              border: "none",
              borderRadius: "8px",
              cursor: isDownloading ? "not-allowed" : "pointer",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              fontWeight: 600,
              opacity: isDownloading ? 0.6 : 1
            }}
          >
            <DownloadIcon /> {isDownloading ? "Downloading..." : "Download ZIP"}
          </button>

          <div style={{
            fontSize: "15px",
            color: "#555",
            padding: "8px 16px",
            border: "1px dashed #ccc",
            borderRadius: "6px",
            minHeight: "24px",
            transition: "all 0.3s",
            backgroundColor: "#f8f9fa",
            width: "100%",
            boxSizing: "border-box"
          }}>
            {isDownloading ? 'Downloading...' : fileName}
          </div>
        </div>

        {/* Progress Bar */}
        <div style={{ width: "100%", border: "1px solid #ddd", padding: "3px", borderRadius: "3px", marginTop: "10px" }}>
          <div style={{
            height: "20px",
            backgroundColor: "#4CAF50",
            width: `${progress}%`,
            borderRadius: "2px",
            textAlign: "center",
            lineHeight: "20px",
            color: "white",
            transition: "width 0.3s ease"
          }}>
            {progress}%
          </div>
        </div>

        {/* Upload Button */}
        <button
          onClick={handleUpload}
          disabled={!isConnected || !selectedFile || isUploading || isDownloading}
          style={{
            marginTop: "20px",
            display: "inline-flex",
            alignItems: "center",
            padding: "12px 25px",
            background: !isConnected || !selectedFile || isUploading || isDownloading ? "#ccc" : "#4CAF50",
            color: "white",
            fontSize: "16px",
            fontWeight: 600,
            borderRadius: "8px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: "none",
            opacity: !isConnected || !selectedFile || isUploading || isDownloading ? 0.6 : 1
          }}
        >
          <CloudUploadIcon /> {isUploading ? "Uploading..." : "Upload to Device"}
        </button>

        {/* Status Message */}
        {messageDisplay(message)}

        {/* Logs Toggle */}
        <button
          style={{
            marginTop: "20px",
            background: "none",
            border: "1px solid #ccc",
            padding: "8px 16px",
            borderRadius: "4px",
            cursor: "pointer",
            color: "#666",
            fontSize: "14px",
            transition: "all 0.2s"
          }}
          onClick={() => setShowLogs(!showLogs)}
        >
          {showLogs ? 'Hide Logs' : 'Show Logs'}
        </button>

        {/* Logs Display */}
        {showLogs && (
          <div
            style={{
              maxHeight: "150px",
              overflowY: "auto",
              textAlign: "left",
              fontSize: "13px",
              color: "#666",
              background: "#f8f8f8",
              padding: "10px",
              borderRadius: "6px",
              marginTop: "10px"
            }}
            ref={logContainerRef}
          >
            {logs.map((log, index) => <div key={index}>{log}</div>)}
          </div>
        )}
      </div>
    </div>
  );
};

export default PublishAudio;